var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Btn',{staticClass:"btn",class:_vm.classes,style:(_vm.styles),attrs:{"loading":_vm.isLoading,"icon":_vm.icon},nativeOn:{"click":function($event){return _vm.onButtonClick.apply(null, arguments)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }